export const DEFAULT_HARVEST_MIN = 25;
export const DEFAULT_HARVEST_MAX = 250;
export const YIELD_KEY = 'dryVolumePerArea';
